import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Link } from "react-router-dom";
import { Copy, Share2, ArrowRight, CheckCircle2 } from "lucide-react";
import Logo from "../Logo";
import { COMPANY } from "../../lib/constants";

export function QrAside({ cardUrl, onShare, onCopy }) {
  return (
    <div className="card-premium overflow-hidden shadow-elevated" data-testid="qr-card">
      <div className="hero-gradient text-white p-5 md:p-6 text-center relative overflow-hidden">
        <div className="absolute -right-10 -top-10 w-40 h-40 rounded-full bg-[var(--melopa-gold)]/30 blur-3xl" />
        <div className="kicker text-[var(--melopa-gold-soft)] mb-1 relative">Scan to Connect</div>
        <h3 className="text-xl md:text-2xl font-extrabold relative">Quick QR Card</h3>
        <p className="text-white/70 text-xs mt-1 relative">Point your phone camera at the code</p>
      </div>
      <div className="p-6 text-center">
        <div className="bg-white inline-flex p-4 rounded-2xl border-2 border-[var(--melopa-gold)]/30 relative">
          <QRCodeCanvas value={cardUrl} size={216} level="H" includeMargin={false} fgColor="#0b1f3b" />
          <div className="absolute inset-0 grid place-items-center pointer-events-none">
            <div className="bg-white rounded-lg p-1.5 shadow-md ring-1 ring-[var(--melopa-gold)]/30">
              <Logo size={32} tone="auto" />
            </div>
          </div>
        </div>
        <div className="text-[11px] text-[var(--melopa-muted)] mt-3 break-all font-mono">{cardUrl}</div>
        <div className="mt-4 flex flex-wrap justify-center gap-2">
          <button onClick={onShare} className="btn-primary" data-testid="qr-share">
            <Share2 className="w-4 h-4" /> Share Digital Card
          </button>
          <button onClick={onCopy} className="btn-outline">
            <Copy className="w-4 h-4" /> Copy Link
          </button>
        </div>
      </div>
    </div>
  );
}

export function IdentifiersBlock() {
  const rows = [
    ["CIN", COMPANY.cin],
    ["GSTIN", COMPANY.gstin],
    ["MSME", COMPANY.msme],
    ["FSSAI", COMPANY.fssai],
  ];
  return (
    <div className="card-premium p-6">
      <div className="kicker mb-1">Trusted Profile</div>
      <h3 className="font-bold text-navy">Company Identifiers</h3>
      <div className="divider-gold" />
      <ul className="text-sm divide-y divide-[var(--melopa-border)]">
        {rows.map(([k, v]) => (
          <li key={k} className="flex items-center justify-between py-2.5 gap-3">
            <span className="text-[11px] uppercase tracking-wider text-[var(--melopa-muted)] font-semibold">{k}</span>
            <span className="font-mono text-[12px] text-navy break-all text-right">{v}</span>
          </li>
        ))}
      </ul>
      <div className="mt-3 flex flex-wrap gap-1.5">
        {["Pvt Ltd", "GST", "MSME", "FSSAI"].map((b) => (
          <span key={b} className="badge-soft">
            <CheckCircle2 className="w-3 h-3 text-[var(--melopa-green)]" /> {b}
          </span>
        ))}
      </div>
    </div>
  );
}

export function QuickLinksBlock() {
  const links = [
    ["/products", "Products & Services"],
    ["/renewable-energy", "Renewable Energy & Lighting"],
    ["/government-contractor", "Government Contractor Profile"],
    ["/downloads", "Downloads"],
    ["/submit", "Submit Requirement"],
  ];
  return (
    <div className="card-premium p-6">
      <div className="kicker mb-1">Explore</div>
      <h3 className="font-bold text-navy">Quick Links</h3>
      <div className="divider-gold" />
      <ul className="grid grid-cols-1 gap-2 text-sm">
        {links.map(([to, label]) => (
          <li key={to}>
            <Link to={to} className="flex items-center justify-between p-2.5 rounded-lg hover:bg-soft transition-colors group">
              <span className="text-navy font-medium">{label}</span>
              <ArrowRight className="w-4 h-4 text-[var(--melopa-muted)] group-hover:text-navy group-hover:translate-x-0.5 transition-all" />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
